/**
 * @type {{
 * HOME: string,
 * HOME_EN: string,
 * HOME_CREATIVE: string,
 * HOME_CREATIVE_EN: string,
 * HOME_EDITORIAL: string,
 * HOME_EDITORIAL_EN: string,
 * RESULTS: string,
 * DETAILS: string,
 * REPORTS_LIST: string,
 * REPORT_DETAILS: string
 * LIGHT_BOX: string,
 * USER_PROFILE: string,
 * CART_LIST: string,
 * DOWNLOAD_LIGHTBOX: string,
 * DOWNLOAD_REPORT: string,
 * }} - The routes for the app.
 */
export const ROUTES = {
    HOME: '/index.html',
    HOME_EN: '/en/index.html',
    HOME_CREATIVE: '/creativo/index.html',
    HOME_CREATIVE_EN: '/en/creative/index.html',
    HOME_EDITORIAL: '/editorial/index.html',
    HOME_EDITORIAL_EN: '/en/editorial/index.html',
    RESULTS: '/buscador/index.html',
    DETAILS: '/detalle-activo/index.html',
    REPORTS_LIST: '/reportajes/index.html',
    REPORT_DETAILS: '/detalle-coleccion/index.html',
    LIGHT_BOX: '/lightboxes/index.html',
    USER_PROFILE: '/perfil/index.html',
    CART_LIST: '/carrito/index.html',
    DOWNLOAD_LIGHTBOX: '/descargar-lightbox/index.html',
    DOWNLOAD_REPORT: '/descargar-reportaje/index.html',
};

/**
 * @type {{
 * HOME: string,
 * RESULTS: string,
 * DETAILS: string,
 * REPORTS_LIST: string,
 * REPORT_DETAILS: string
 * LIGHT_BOX: string,
 * USER_PROFILE: string,
 * CART_LIST: string,
 * DOWNLOAD_LIGHTBOX: string,
 * DOWNLOAD_REPORT: string,
 * }} - The routes for the app.
 */
export const ROUTES_OLD = {
    HOME: '/index.html',
    RESULTS: '/search-results/index.html',
    DETAILS: '/details-view/index.html',
    REPORTS_LIST: '/reports-list-view/index.html',
    REPORT_DETAILS: '/report-details-view/index.html',
    LIGHT_BOX: '/lightbox-view/index.html',
    USER_PROFILE: '/user-profile/index.html',
    CART_LIST: '/cart-list-view/index.html',
    DOWNLOAD_LIGHTBOX: '/download-lightbox-view/index.html',
    DOWNLOAD_REPORT: '/download-report-view/index.html',
};

/**
 * @type {{
 *  HOME: string,
 *  RESULTS: string,
 *  DETAILS: string,
 *  REPORTS_LIST: string,
 *  REPORT_DETAILS: string
 *  LIGHT_BOX: string,
 *  USER_PROFILE: string,
 *  CART_LIST: string,
 *  DOWNLOAD_LIGHTBOX: string,
 *  DOWNLOAD_REPORT: string,
 * }} - Mapping routes from old to new.
 */
export const MAPPING_ROUTES = {
    [ROUTES_OLD.HOME]: ROUTES.HOME,
    [ROUTES_OLD.RESULTS]: ROUTES.RESULTS,
    [ROUTES_OLD.DETAILS]: ROUTES.DETAILS,
    [ROUTES_OLD.REPORTS_LIST]: ROUTES.REPORTS_LIST,
    [ROUTES_OLD.REPORT_DETAILS]: ROUTES.REPORT_DETAILS,
    [ROUTES_OLD.LIGHT_BOX]: ROUTES.LIGHT_BOX,
    [ROUTES_OLD.USER_PROFILE]: ROUTES.USER_PROFILE,
    [ROUTES_OLD.CART_LIST]: ROUTES.CART_LIST,
    [ROUTES_OLD.DOWNLOAD_LIGHTBOX]: ROUTES.DOWNLOAD_LIGHTBOX,
    [ROUTES_OLD.DOWNLOAD_REPORT]: ROUTES.DOWNLOAD_REPORT,
};
